import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  einTitle: {
    defaultMessage: 'EIN',
    id: 'us_ein_title',
    description: 'US EIN field title',
  },
  dbaTitle: {
    defaultMessage: 'DBA',
    id: 'us_dba_title',
    description: 'US DBA field title',
  },
  tlcTitle: {
    defaultMessage: 'TLC Base Affiliation Number',
    id: 'us_tlc_base_affiliation_title',
    description: 'US TLC base affiliation number field title',
  },
  ssnTitle: {
    defaultMessage: 'Social Security Number',
    id: 'us_ssn_title',
    description: 'US SSN field title',
  },
});
